// extracted by mini-css-extract-plugin
export var rgIcon = "styles-module--rg-icon--38a5d";
export var svg = "styles-module--svg--1b19f";